<script setup>
import DialogModal from '@/Components/DialogModal.vue'
import InputError from '@/Components/InputError.vue'
import TextInput from '@/Components/TextInput.vue'
import { ref, onMounted, nextTick, watch } from 'vue'
import { useForm } from '@inertiajs/vue3'
import PrimaryButton from '@/Components/PrimaryButton.vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const modal_show = ref(false)

onMounted(() => {
    if (checkStorage()) {
        modal_show.value = true
    }
})

const checkStorage = () => {
    if (typeof window !== 'undefined') {
        return !localStorage.getItem('couponModalShown')
    }
    return false
}

function denyCoupon() {
    modal_show.value = false
    form.reset()
    localStorage.setItem('couponModalShown', 'true')
}

const form = useForm({ email: '' })

function submit() {
    form.post(route('newsletters.store'), {
        preserveScroll: true,
        onSuccess: () => {
            modal_show.value = false
            form.reset()
            localStorage.setItem('couponModalShown', 'true')
        },
    })
}
</script>

<template>
    <DialogModal
        :show="modal_show"
        @close="denyCoupon()"
    >
        <template #close>
            <button
                @click="denyCoupon"
                class="rounded-lg bg-red-950 ring-2 ring-transparent hover:ring-red-900"
            >
                <XMarkIcon class="size-8 text-red-500" />
            </button>
        </template>

        <template #title> Získejte slevu 10% </template>

        <template #subtitle> Zadejte svůj e-mail a získejte slevu 10% na první daňové přiznání. </template>

        <template #content>
            Na e-mail Vám přijde slevový kupón, který uplatníte při platbě.

            <div class="absolute right-0">
                <img
                    src="/src/hero/file.png"
                    alt="App screenshot"
                    class="z-10 h-[5rem] xl:h-[10rem]"
                />
            </div>

            <div class="mt-4 w-full">
                <TextInput
                    v-model="form.email"
                    type="email"
                    inputmode="email"
                    class="mx-auto mt-1 block w-3/4"
                    placeholder="Váš email"
                    autocomplete="email"
                />

                <InputError
                    :message="form.errors.email"
                    class="mt-2"
                />
            </div>
        </template>

        <template #footer>
            <PrimaryButton
                class="ml-2"
                @click="submit"
            >
                Získat Slevu
            </PrimaryButton>
        </template>
    </DialogModal>
</template>
